import Bacon from 'baconjs';

const DEFAULT_VIEW = 'list';
const DEFAULT_VIEW_LEADS = 'board';

export default function (dispatcher, topLevelEntity) {
    const {push, stream} = dispatcher;
    const urlStream = stream('URL').map('.query.view');

    const selected = Bacon.update(
        'list',
        [urlStream],
        (unused, newValue) => newValue,
        [stream('VIEW-UPDATE')],
        (unused, newValue) => newValue
    ).map((newValue) => {
        if (topLevelEntity === 'leads') {
            return newValue || DEFAULT_VIEW_LEADS;
        } else {
            return newValue || DEFAULT_VIEW;
        }
    });

    stream('VIEW-UPDATE')
        .merge(urlStream)
        .skipDuplicates()
        .filter((view) => view === 'explore')
        .onValue(() =>
            Analytics.trackEvent(
                Analytics.categories.views,
                Analytics.actions.views.leadsExploreView
            )
        );

    return Bacon.combineTemplate({
        selected,
        updateView(viewString) {
            push('VIEW-UPDATE', viewString);
        },
    });
}
